module.exports = __webpack_public_path__ + "img/file-icon_xlsx.140e7989.svg";